import firebase from 'firebase/app'
import 'firebase/database'

const db = firebase.database()
const snapshotParser = (snapshotsObject) => {
  return Object.keys(snapshotsObject).map(x => {
    return {
      ...snapshotsObject[x],
      id: x
    }
  })
}

export default {
  namespaced: true,
  state: {
    fontsRef: null,
    userFonts: null,
    teamFontsRef: null,
    teamFonts: null,
    projectFonts: {}
  },
  getters: {
    getFontUID (state) {
      return state.fontUID
    },
    getUserFonts (state) {
      const userFonts = state.userFonts || {}
      const teamFonts = state.teamFonts || {}
      const allFonts = { ...userFonts, ...teamFonts }
      return snapshotParser(allFonts)
    },
    projectFonts (state) {
      return state.projectFonts
    }
  },
  mutations: {
    setFontsRef (state, ref) {
      state.fontsRef = ref
    },
    setUserFonts (state, fonts) {
      state.userFonts = fonts
    },
    setTeamFontsRef (state, ref) {
      state.teamFontsRef = ref
    },
    setTeamFonts (state, fonts) {
      state.teamFonts = fonts
    },
    setProjectFonts (state, fonts) {
      state.projectFonts = fonts
    },
    addProjectFont (state, font) {
      state.projectFonts = { ...state.projectFonts, ...font }
    }
  },
  actions: {
    /**
     * These actions are managing projectFonts object.
     * When user editing the project I'm saving all used fonts in this object and saving it on concept_test(project) node in firebase.
     * When we loading project's render(flow), I'm checking if there is any cutom font used in this project.
     * And, if there is, preloading it to avoid FOUT.
     * This logic can be found in landingrouter clound function.
     * */
    cleanProjectFonts ({ commit }) {
      commit('setProjectFonts', null)
    },
    setProjectFonts ({ commit }, fonts) {
      commit('setProjectFonts', fonts)
    },
    addProjectFont ({ commit }, font) {
      commit('addProjectFont', font)
    },
    /** */
    getUserFonts ({ state, rootState, dispatch, commit }) {
      const userId = rootState.auth.user && rootState.auth.user.uid
      const listenig = !!state.fontsRef

      if (listenig) {
        state.fontsRef.off()
        commit('setFontsRef', null)
      }
      const fontsRef = db.ref('fonts').orderByChild('userUID').equalTo(userId)
      commit('setFontsRef', fontsRef)

      fontsRef.on('value', snapshot => {
        const fonts = snapshot.val()
        commit('setUserFonts', fonts)
      })
      dispatch('getTeamFonts')
    },

    getTeamFonts ({ state, rootState, commit }) {
      const enterpriseId = rootState.auth.user && rootState.auth.user.enterprise && rootState.auth.user.enterprise.id
      const listenig = !!state.teamFontsRef
      if (!enterpriseId) return

      if (listenig) {
        state.teamFontsRef.off()
        commit('setTeamFontsRef', null)
      }
      const teamFontsRef = db.ref('fonts').orderByChild('enterpriseUID').equalTo(enterpriseId)
      commit('setTeamFontsRef', teamFontsRef)

      teamFontsRef.on('value', snapshot => {
        const fonts = snapshot.val()
        commit('setTeamFonts', fonts)
      })
    },

    async uploadFontToStorage ({}, { file, fontPushId }) {
      const fileName = Date.now() + '_' + file.name.trim().replace(/\s/g, '_')
      const storageRef = firebase.storage().ref(`fonts/${fontPushId}/${fileName}`)

      const uploadTask = storageRef.put(file)

      return new Promise((resolve, reject) => {
        uploadTask.on('state_changed',
          (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            console.log('Upload is ' + progress + '% done')
          },
          (err) => reject(err),
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              resolve(downloadURL)
            })
          }
        )
      })
    },

    async processFontFile ({ dispatch }, { fileWrap, fontPushId }) {
      const file = fileWrap.file
      const fileLink = await dispatch('uploadFontToStorage', { file, fontPushId, type: fileWrap.fileType })
      return {
        url: fileLink,
        type: fileWrap.fileType === 'ttf' ? 'truetype' : fileWrap.fileType
      }
    },

    async uploadFontsFiles ({ dispatch }, { files, fontPushId }) {
      return Promise.all(files.map(x => dispatch('processFontFile', { fileWrap: x, fontPushId })))
    },

    async addNewFont ({ rootState, dispatch }, { name, files, link, cdnFont }) {
      const userId = rootState.auth.user && rootState.auth.user.uid
      const enterpriseId = rootState.auth.user && rootState.auth.user.enterprise && rootState.auth.user.enterprise.id
      const fontPushId = db.ref('/fonts').push().getKey()
      const fontRef = db.ref(`/fonts/${fontPushId}`)

      const payload = {
        name: name,
        link: '',
        userUID: userId,
        cdnFont: cdnFont,
        enterpriseUID: enterpriseId || ''
      }

      if (cdnFont) {
        payload.link = link
      } else {
        payload.link = await dispatch('uploadFontsFiles', { files, fontPushId })
      }

      return fontRef.set(payload)
    },
    async archiveFont ({}, id) {
      const fontRef = db.ref(`/fonts/${id}`)
      await fontRef.update({
        archived: true
      })
    }
  }
}
